import { banner } from "../assets";
export const UtilityServices = {
  getPdfCSS() {
    return `body {
                margin: 0;
                font-family: var(--bs-font-sans-serif);
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
                color: #212529;
                background-color: #fff;
                -webkit-text-size-adjust: 100%;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
            }

            .App {
                text-align: center;
                font-size: 16px;
            }

            .bannerImage {
                background: url(${LocationOrigin}${banner}) no-repeat 0 0;
                padding: 25px 0 45px;
                position: relative;
                background-size: 100% 100%;
            }

            img,
            svg {
                vertical-align: middle;
            }

            .download-results-page-wrapper {
                width: 100%;
                font-family: 'J&J CircularTT-Medium';
                color: #333;
            }

            .download-results-page-contents-wrapper {
                font-size: 14px;
                text-align: left;
                padding: 1% 3%;
            }

            .results-div-docTitle-wrapper {
                flex: 1 1;
                padding-right: 1%;
            }

            .resultDetailsDiv {
                width: 95%;
                display: flex;
                flex-direction: column;
            }

            .results-title-action-outer-wrapper {
                display: flex;
                flex-direction: row;
                padding-top: 0.5%;
            }

            .resultDetailsDiv a {
                color: #EB1700;
                font-weight: bold;
                font-size: 14px;
                display: inline;
                word-break: break-word;
                cursor: pointer;
                text-decoration: none;
            }

            .citation-results-meta-property-wrapper {
                padding-top: 1%;
            }

            .PHM-MetaDataProperty {
                box-sizing: border-box;
                font-size: 14px;
                line-height: 1.42857143;
                color: #333;
            }
            .PHM-MetaDataProperty-SubType {
                box-sizing: border-box;
                font-size: 14px;
                line-height: 1.42857143;
                color: #333;
                margin-left: 30px;
            }
            .resultsDivFooter {
                margin: 20px 0;
                height: 1px;
                border-bottom: 1px solid #dcdcdc;
                width: 105%;
                float: left;
            }
            .citation-right-find-descriptor-wrapper {
                font-family: 'J&J CircularTT-Medium';
                padding-bottom: 5px;
                display: inline-flex;
                flex-direction: row;
            }
            .citation-right-find-descriptor-header-wrapper {
                background: #5e8ebd;
                color: white;
                padding-left: 8px !important;
                padding: 4px;
                text-align: left;
                border-radius: 6px;
                cursor: pointer;
                width: 325px;
            }
            .order-info-icn {
                height: 17px;
                width: 17px;
                border-radius: 14px;
                margin-right: 5px;
                float: right;
                margin-top: 2px;
                vertical-align: middle;
            }
            .citation-info-icon-wrapper {
                height: 17px;
                width: 17px;
                float: left;
                margin-left: -20px;
                margin-top: 1px;
            }
            .document-descriptor-header-wrapper{
                margin: 5px 0px 3px;
                color: white;
                background: linear-gradient(0deg, rgb(2, 0, 36) 0%, rgba(227, 152, 67, 0.99) 0%, rgba(243, 144, 29, 0.73) 100%);
                padding: 6px;
                border-radius: 6px;
                cursor: pointer;
                font-weight: bold;
                text-shadow: rgb(204 132 24) 2px 2px;
              }
              .document-descriptor-wrapper{
                font-family: 'J&J CircularTT-Medium';
                padding-bottom: 5px;
              }.document-descriptor-img{
                width: 17px;
                height: 17px;
                padding-bottom: 3px;
                padding-left: 2px;
                transition: all 0.3s ease 0s;
                transform: rotate(0deg);
              }
              .document-descriptor-img-rotate{
                width: 17px;
                height: 17px;
                padding-bottom: 3px;
                padding-left: 2px;
                transition: all 0.3s ease 0s;
                transform: rotate(90deg);
              }
              .document-descriptor-text-wrapper{
                padding: 14px;
                  background: linear-gradient(0deg, rgb(2, 0, 36) 0%, rgba(252, 221, 1, 0.26) 0%, rgba(252, 222, 11, 0.29) 100%);
                  font-size: 13.5px;
                  border-radius: 0px 0px 10px 10px;
                  display: block;
              }
              .keyTakeaways-info-icn{
                height: 22px;
                width:22px;
                border-radius: 14px;
                margin-right: 5px;
                float: right;
              }`;
  },
  getPdfCSSGenAI() {
    return `.bannerImage {
                padding: 15px 0 15px;
                position: relative;
                background-size: 100% 100%;
                text-align: center
            }

            img,
            svg {
                vertical-align: middle;
            }

            .download-results-page-wrapper {
                width: 100%;
                font-family: 'J&J CircularTT-Medium';
                color: #333;
            }

            .gen-ai-result-ContentWrapper {
                display: flex;
                text-align: left;
                flex-direction: column;
                width: 100%;
            }
              .gen-ai-results-wrapper {
               background: #ffffff 0% 0% no-repeat padding-box;
               opacity: 1;
               word-break: break-word;
            }

            .results-div-docTitle-wrapper {
                flex: 1 1;
                padding-right: 1%;
            }
            .meta-data-row-bgcolor {
              background: #FAF9F9;
              padding: 8px;
            }
            .gen-ai-resultDetailsDiv a {
              font-size: 12px !important;
              text-decoration: none;
              overflow: hidden;
              float: left;
            }

          .doc-card {
              width: 100%;
              padding: 12px 12px 12px 12px;
              box-sizing: border-box;
              display: inline-flex;
              flex-direction: column;
              gap: 8px;
              font-family: "Johnson Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
              color: #364153;
          }

          /* Inner container to keep consistent widths like original */
          .doc-card-inner {
              display: flex;
              flex-direction: column;
              gap: 12px;
              width: 100%;
          }

/* Rows */
.doc-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
        width: 100%;
}

.header-row {
    gap: 8px;
}

.left-icons {
    display: flex;
    gap: 4px;
    align-items: center;
}

/* checkbox & small square */
.checkbox-outline {
    display: flex;
    align-items: center;
}

.checkbox-border {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border: 2px solid #212121;
    position: absolute;
    left: 0;
    top: 0;
}

.small-square {
    display: flex;
}

.small-square-inner {
    width: 12px;
    height: 12px;
    position: absolute;
    left: 2px;
    top: 2px;
    outline: 1.5px #212121 solid;
    outline-offset: -0.75px;
}

/* title */
.doc-title {
    padding: 0 12px;
}

.doc-title,
.doc-title>a {
    flex: 1 1 0;
    color: #EB1700;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    word-wrap: break-word;
    min-width: 0;
    /* allow truncation in flex */
    text-decoration: none;
}

.doc-title>a:hover {
    text-decoration: underline;
}

.doc-title>a:hover,
.doc-title>a:visited {
    color: #EB1700;
}
.meta-item>.meta-value>a{
    text-decoration: none;
}
.meta-item>.meta-value>a,
.meta-item>.meta-value>a:hover,
.meta-item>.meta-value>a:visited {
    color: #EB1700;
}

.doc-title>a:hover {
    text-decoration: underline;
}

/* action icons on header */
.action-icons {
    display: flex;
    align-items: center;
    gap: 8px;
}

.gen-ai-action-icon-btn {
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
}

.gen-ai-action-icon-btn-inner {
    padding: 2px;
    position: absolute;
    left: 0;
    top: 0;
    box-shadow: 0 1px 4px rgba(12, 12, 13, 0.05) inset;
    border-radius: 4px;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
}

.icon-shape {
    width: 16px;
    height: 16px;
    position: relative;
    overflow: hidden;
    border-radius: 4px;
}

.icon-shape.tall {
    height: 16px;
}

.icon-shape.square {}

/* description */
.description-row {
    justify-content: flex-start;
}
.citation-info-icon-wrapper
{
float: left;
    width: 18px;
    margin-left: -18px;
    z-index: 10;
    position: absolute;
    }
.description {
    flex: 1 1 0;
    color: #4A5565;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    word-wrap: break-word;
    padding-left: 12px;
}

/* metadata grid */
.meta-row {
    /* justify-content: flex-end; */
    gap: 8px;
}

.meta-column {
    width: calc(50% - 2px);
    float: left;
    gap: 4px;
}

.meta-item {
    padding: 1px 12px;
    width: 100%;
    overflow: hidden;
}

.meta-label {
    color: #364153;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    float: left;
    overflow: hidden;
}

.meta-value {
    color: #364153;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    margin-left: 4px;
    overflow: hidden;
    float: left;
}
.meta-data-row-bgcolor{
    background: #FAF9F9;
    padding: 8px;
    width: 100%;
    overflow: hidden;
}
/* action badge bottom-right */
.action-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border-radius: 12px;
    background: #EB1700;
    /* light background */
    align-self: flex-end;
    cursor: pointer;
}

.badge-icon {
    width: 16px;
    height: 16px;
    position: relative;
    background: transparent;
    border-radius: 2px;
    box-sizing: border-box;
    outline: 1.5px #81766F solid;
    outline-offset: -0.75px;
}

.badge-text {
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
}

div.left-icons>div.checkbox-outline>input[type=checkbox] {
    accent-color: #eb1600;
}

.gen-ai-resultDetailsDiv {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.gen-ai-resultsDivFooter {
    /* margin: 20px 0;
    height: 1px;
    border-bottom: 1px solid #dcdcdc; */
    width: 100%;
    float: left;
}

    .rm-wrapper {
    color: #364153;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    margin-left: 4px;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
}

/* Base content styling */
.rm-content {
    /* allow the CSS variable --rm-lines to be used by JS or CSS if desired */
    --rm-lines: 2;
    transition: max-height 0.25s ease;
    /* optional nice reveal if you also animate max-height */

}

/* Collapsed (two-line clamp) */
.rm-content.rm-collapsed {
    display: -webkit-box;
    -webkit-line-clamp: var(--rm-lines);
    -webkit-box-orient: vertical;
    overflow: hidden;
    /* For browsers that support the newer syntax: */
    /* Uncomment if you want to try the non-webkit syntax in supporting browsers */
    /* display: box; line-clamp: var(--rm-lines); box-orient: vertical; */
    width: calc(100% - 10px);
    word-break: break-all;
}

/* Expanded: show full content */
.rm-content.rm-expanded {
    display: block;
    /* remove -webkit-box so it shows full text */
    -webkit-line-clamp: initial;
    -webkit-box-orient: initial;
    overflow: visible;
    width: calc(100% - 85px);
}

/* Simple button styling */
.rm-toggle {
    color: var(--color-text-primary, #EB1700);
    text-align: center;
    font-variant-numeric: lining-nums tabular-nums;
    font-feature-settings: 'liga' off;

    /* Desktop/Body-S-Medium */
    font-family: "Johnson Text";
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    background: none;
    /* 114.286% */
}

.rm-toggle:focus {
    outline: 2px solid #96c8ff;
    outline-offset: 2px;
}
/* gen-ai-document-item-description.css
   All class names start with the required prefix.
*/

.gen-ai-document-item-description {
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 12px 12px 0px;
  background: #ffffff;
  font-family: "Johnson Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #212121;
}

/* Badge */
.gen-ai-document-item-description__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #EB1700;
  /* light warning background */
  width: fit-content;
  border: 1px solid #EB1700;
}

.gen-ai-document-item-description__badge-label {
  color: #ffffff;
  /* warning text */
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.gen-ai-document-item-description__badge-icon {
  width: 16px;
  height: 16px;
  position: relative;
  display: inline-block;
}

/* simple visual shapes to match the example */
.gen-ai-document-item-description__badge-icon--left::before {
  content: "";
  display: block;
  width: 13.33px;
  height: 13.33px;
  position: absolute;
  left: 1.33px;
  top: 1.33px;
  outline: 1.5px #EB1700 solid;
  outline-offset: -0.75px;
  border-radius: 2px;
}

.gen-ai-document-item-description__badge>svg {
  cursor: pointer;
}

.gen-ai-document-item-description__badge-icon--right::before {
  content: "";
  display: block;
  width: 8px;
  height: 4px;
  position: absolute;
  left: 4px;
  top: 6px;
  outline: 2px #EB1700 solid;
  outline-offset: -1px;
  border-radius: 1px;
}

/* Card wrapper */
.gen-ai-document-item-description__card {
  /* width: 600px; */
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 32px;
   border: 1px solid #A9A9A9 ;
}

/* Header row */

/* List of versions */
.gen-ai-document-item-description__list {
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* Each row */
.gen-ai-document-item-description__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px;
  /* border-bottom: 1px solid #A9A9A9; */
  color: #000000;
}

.gen-ai-document-item-description-divider {
  border-top: 1px solid #A9A9A9 ;
  padding: 2px;
  margin: 6px 0px 6px 0px;
}
/* gen-ai-key-enclosure.css
   All class names start with the required prefix.
*/

.gen-ai-key-enclosure {
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 12px 12px 0px;
  background: #ffffff;
  font-family: "Johnson Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #212121;
}

/* Badge */
.gen-ai-key-enclosure__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #EB1700;
  /* light warning background */
  width: fit-content;
  border: 1px solid #EB1700;
}

.gen-ai-key-enclosure__badge-label {
  color: #ffffff;
  /* warning text */
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.gen-ai-key-enclosure__badge-icon {
  width: 16px;
  height: 16px;
  position: relative;
  display: inline-block;
}

/* simple visual shapes to match the example */
.gen-ai-key-enclosure__badge-icon--left::before {
  content: "";
  display: block;
  width: 13.33px;
  height: 13.33px;
  position: absolute;
  left: 1.33px;
  top: 1.33px;
  outline: 1.5px #EB1700 solid;
  outline-offset: -0.75px;
  border-radius: 2px;
}

.gen-ai-key-enclosure__badge>svg {
  cursor: pointer;
}

.gen-ai-key-enclosure__badge-icon--right::before {
  content: "";
  display: block;
  width: 8px;
  height: 4px;
  position: absolute;
  left: 4px;
  top: 6px;
  outline: 2px #EB1700 solid;
  outline-offset: -1px;
  border-radius: 1px;
}

/* Card wrapper */
.gen-ai-key-enclosure__card {
  /* width: 600px; */
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  border: 1px solid #A9A9A9;
}

/* Header row */

/* List of versions */
.gen-ai-key-enclosure__list {
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* Each row */
.gen-ai-key-enclosure__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px;
  /* border-bottom: 1px solid #F7F7FC; */
   color: #000000;
}

.gen-ai-key-enclosure-divider {
  border-top: 1px solid #A9A9A9;
  padding: 2px;
  margin: 6px 0px 6px 0px;
}

.gen-ai-key-enclosure__row>a,
.gen-ai-key-enclosure__row>a:hover ,
.gen-ai-key-enclosure__row>a:visited {
  color: var(--Miscellaneous-Sidebar-Text---Selected, #000000);
  text-decoration: none;
}

.gen-ai-key-enclosure__row>a:hover {
  text-decoration: underline;
}
  /* gen-ai-greenlight-version.css
   All class names are prefixed with gen-ai-greenlight-version
   Tweak tokens/colors to match your design system if needed.
*/

.gen-ai-greenlight-version__root {
    width: 100%;
    max-width: 600px;
    padding: 12px 12px 12px 0px;
    background: #ffffff;
    display: inline-flex;
    flex-direction: column;
    gap: 12px;
    box-sizing: border-box;
    font-family: "Johnson Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;

}

/* Badge */
.gen-ai-greenlight-version__badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    border-radius: 12px;
    background: var(--color-background-warning, #EB1700);
    width: fit-content;
    border: 1px solid #EB1700;
}

.gen-ai-greenlight-version__badge>svg {
    cursor: pointer;
}

.gen-ai-greenlight-version__badge-icon {
    width: 16px;
    height: 16px;
    position: relative;
    display: inline-block;
    box-sizing: border-box;
}

.gen-ai-greenlight-version__badge-icon--left::before {
    content: "";
    position: absolute;
    left: 1.33px;
    top: 1.33px;
    width: 13.33px;
    height: 13.33px;
    outline: 1.50px solid #F37820;
    outline-offset: -0.75px;
    box-sizing: border-box;
    border-radius: 2px;
}

.gen-ai-greenlight-version__badge-icon--right::before {
    content: "";
    position: absolute;
    left: 4px;
    top: 6px;
    width: 8px;
    height: 4px;
    outline: 2px solid #F37820;
    outline-offset: -1px;
    box-sizing: border-box;
}

/* Badge label */
.gen-ai-greenlight-version__badge-label {
    color: #ffffff;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
}

/* Panel */
.gen-ai-greenlight-version__panel {
    width: 100%;
    background: var(--color-background-warning, #ffffff);
    border-radius: 12px;
    padding: 0;
    box-sizing: border-box;
    border: 1px solid #A9A9A9;
}

/* Header row */
.gen-ai-greenlight-version__header {
    display: flex;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #A9A9A9;
    box-sizing: border-box;
    background: #EB1700;
    color: #ffffff;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}

.gen-ai-greenlight-version__header-left {
    flex: 1 1 0;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
    width: 200px;
}

.gen-ai-greenlight-version__object-name {
    color: var(--JnJ-black-text, #ffffff);
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    width: 200px;
}

.gen-ai-greenlight-version__header-right {
    width: 200px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    justify-content: flex-start;
}

.gen-ai-greenlight-version__approved-label {
    color: var(--JnJ-black-text, #ffffff);
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
}

/* List */
.gen-ai-greenlight-version__list {
    display: flex;
    flex-direction: column;
    gap: 0;
     
}

.gen-ai-greenlight-version__list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    /* height: 32px; */
    padding: 6px 16px;
    border-bottom: 1px solid #F7F7FC;
    box-sizing: border-box;
    border-top: 1px solid #A9A9A9;
}

.gen-ai-greenlight-version__version-id {
    color: var(--Miscellaneous-Sidebar-Text---Selected, #0088FF);
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    /* flex-basis: 0;
    flex-grow: 1; */
    overflow: hidden;
    /* text-overflow: ellipsis;
    white-space: nowrap; */
    max-width: 200px;
}

.gen-ai-greenlight-version__version-id>a,
.gen-ai-greenlight-version__version-id>a:hover,
.gen-ai-greenlight-version__version-id>a:visited {
    color: var(--Miscellaneous-Sidebar-Text---Selected, #000000);
    text-decoration: none;
}

.gen-ai-greenlight-version__version-id>a:hover {
    text-decoration: underline;
}

.gen-ai-greenlight-version__version-date {
    color: var(--JnJ-black-text, #212121);
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    padding-left: 16px;
    white-space: nowrap;
}

/* Last item: remove bottom border (optional) */
.gen-ai-greenlight-version__list-item:last-child {
    border-bottom: none;
}

/* Responsive adjustments */
@media (max-width: 520px) {
    .gen-ai-greenlight-version__header-right {
        display: none;
    }

    .gen-ai-greenlight-version__version-date {
        font-size: 13px;
    }
}
/* gen-ai-key-takeaways.css
   All class names start with the required prefix.
*/

.gen-ai-key-takeaways {
  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 12px 12px 0px;
  background: #ffffff;
  font-family: "Johnson Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #212121;
}

/* Badge */
.gen-ai-key-takeaways__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #EB1700;
  /* light warning background */
  width: fit-content;
  border: 1px solid #EB1700;
}

.gen-ai-key-takeaways__badge-label {
  color: #ffffff;
  /* warning text */
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}

.gen-ai-key-takeaways__badge-icon {
  width: 16px;
  height: 16px;
  position: relative;
  display: inline-block;
}

/* simple visual shapes to match the example */
.gen-ai-key-takeaways__badge-icon--left::before {
  content: "";
  display: block;
  width: 13.33px;
  height: 13.33px;
  position: absolute;
  left: 1.33px;
  top: 1.33px;
  outline: 1.5px #EB1700 solid;
  outline-offset: -0.75px;
  border-radius: 2px;
}

.gen-ai-key-takeaways__badge>svg {
  cursor: pointer;
}

.gen-ai-key-takeaways__badge-icon--right::before {
  content: "";
  display: block;
  width: 8px;
  height: 4px;
  position: absolute;
  left: 4px;
  top: 6px;
  outline: 2px #EB1700 solid;
  outline-offset: -1px;
  border-radius: 1px;
}

/* Card wrapper */
.gen-ai-key-takeaways__card {
  /* width: 600px; */
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  border: 1px solid #A9A9A9;
   color: #000000;
}

/* Header row */

/* List of versions */
.gen-ai-key-takeaways__list {
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* Each row */
.gen-ai-key-takeaways__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 16px;
  /* border-bottom: 1px solid #EB1700; */
  border-radius: 12px;
   color: #000000;
}

.gen-ai-key-takeaways-divider {
  border-top: 1px solid #A9A9A9;
  border-radius: 12px;
  padding: 2px;
  margin: 6px 0px 6px 0px;
}   
/* gen-ai-key-summary.css
   All class names start with the required prefix.
*/

.gen-ai-key-summary {
    display: inline-flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px 12px 12px 0px;
    background: #ffffff;
    font-family: "Johnson Text", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
    color: #212121;
}

/* Badge */
.gen-ai-key-summary__badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 8px;
    border-radius: 12px;
    background: #EB1700;
    /* light warning background */
    width: fit-content;
    border: 1px solid #EB1700;
}

.gen-ai-key-summary__badge-label {
    color: #ffffff;
    /* warning text */
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
}

.gen-ai-key-summary__badge-icon {
    width: 16px;
    height: 16px;
    position: relative;
    display: inline-block;
}

/* simple visual shapes to match the example */
.gen-ai-key-summary__badge-icon--left::before {
    content: "";
    display: block;
    width: 13.33px;
    height: 13.33px;
    position: absolute;
    left: 1.33px;
    top: 1.33px;
    outline: 1.5px #EB1700 solid;
    outline-offset: -0.75px;
    border-radius: 2px;
}

.gen-ai-key-summary__badge>svg {
    cursor: pointer;
}

.gen-ai-key-summary__badge-icon--right::before {
    content: "";
    display: block;
    width: 8px;
    height: 4px;
    position: absolute;
    left: 4px;
    top: 6px;
    outline: 2px #EB1700 solid;
    outline-offset: -1px;
    border-radius: 1px;
}

/* Card wrapper */
.gen-ai-key-summary__card {
    /* width: 600px; */
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 32px;
    border: 1px solid #A9A9A9;
}

/* Header row */

/* List of versions */
.gen-ai-key-summary__list {
    display: flex;
    flex-direction: column;
    padding: 0;
}

/* Each row */
.gen-ai-key-summary__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 16px;
    /* border-bottom: 1px solid #F7F7FC; */
     color: #000000;
}

.gen-ai-key-summary-divider {
    border-top: 1px solid #A9A9A9;
    padding: 2px;
    margin: 6px 0px 6px 0px;
}

.gen-ai-key-summary-btnNotebook {
    margin: 0 auto;
    cursor: pointer;
    background: #EB1700 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
    padding: 4px 5px;
    width: 140px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    height: 24px;
    color: #FFFFFF;
    font-size: 14px;
    background: #EB1700;
}

.gen-ai-key-btnNotebook {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px 16px;
    border-bottom: 1px solid #F7F7FC;
}  
    `;
  },
  getNotebookPdfCSS() {
    return `body {
                margin: 0;
                font-family: var(--bs-font-sans-serif);
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.5;
                color: #212529;
                background-color: #fff;
                -webkit-text-size-adjust: 100%;
                -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
                padding: 30px 35px 0px 25px;
            }

            .App {
                text-align: center;
                font-size: 16px;
            }

            .bannerImage {
                background: url(${LocationOrigin}${banner}) no-repeat 0 0;
                padding: 25px 0 45px;
                position: relative;
                background-size: 100% 100%;
            }

            img,
            svg {
                vertical-align: middle;
            }

            .download-results-page-wrapper {
                width: 100%;
                font-family: 'J&J CircularTT-Medium';
                color: #333;
            }

            .download-results-page-contents-wrapper {
                font-size: 14px;
                text-align: left;
                padding: 1% 3%;
            }

            .results-div-docTitle-wrapper {
                flex: 1 1;
                padding-right: 1%;
            }

            .resultDetailsDiv {
                width: 95%;
                display: flex;
                flex-direction: column;
            }

            .results-title-action-outer-wrapper {
                display: flex;
                flex-direction: row;
                padding-top: 0.5%;
            }

            .resultDetailsDiv a {
                color: #EB1700;
                font-weight: bold;
                font-size: 14px;
                display: inline;
                word-break: break-word;
                cursor: pointer;
                text-decoration: none;
            }

            .citation-results-meta-property-wrapper {
                padding-top: 1%;
            }

            .PHM-MetaDataProperty {
                box-sizing: border-box;
                font-size: 14px;
                line-height: 1.42857143;
                color: #333;
            }
            .PHM-MetaDataProperty-SubType {
                box-sizing: border-box;
                font-size: 14px;
                line-height: 1.42857143;
                color: #333;
                margin-left: 30px;
            }
            .resultsDivFooter {
                margin: 20px 0;
                height: 1px;
                border-bottom: 1px solid #dcdcdc;
                width: 105%;
                float: left;
            }
            .citation-right-find-descriptor-wrapper {
                font-family: 'J&J CircularTT-Medium';
                padding-bottom: 5px;
                display: inline-flex;
                flex-direction: row;
            }
            .citation-right-find-descriptor-header-wrapper {
                background: #5e8ebd;
                color: white;
                padding-left: 8px !important;
                padding: 4px;
                text-align: left;
                border-radius: 6px;
                cursor: pointer;
                width: 325px;
            }
            .order-info-icn {
                height: 17px;
                width: 17px;
                border-radius: 14px;
                margin-right: 5px;
                float: right;
                margin-top: 2px;
                vertical-align: middle;
            }
            .citation-info-icon-wrapper {
                height: 17px;
                width: 17px;
                float: left;
                margin-left: -20px;
                margin-top: 1px;
            }
            .document-descriptor-header-wrapper{
                margin: 5px 0px 3px;
                color: white;
                background: linear-gradient(0deg, rgb(2, 0, 36) 0%, rgba(227, 152, 67, 0.99) 0%, rgba(243, 144, 29, 0.73) 100%);
                padding: 6px;
                border-radius: 6px;
                cursor: pointer;
                font-weight: bold;
                text-shadow: rgb(204 132 24) 2px 2px;
              }
              .document-descriptor-wrapper{
                font-family: 'J&J CircularTT-Medium';
                padding-bottom: 5px;
              }.document-descriptor-img{
                width: 17px;
                height: 17px;
                padding-bottom: 3px;
                padding-left: 2px;
                transition: all 0.3s ease 0s;
                transform: rotate(0deg);
              }
              .document-descriptor-img-rotate{
                width: 17px;
                height: 17px;
                padding-bottom: 3px;
                padding-left: 2px;
                transition: all 0.3s ease 0s;
                transform: rotate(90deg);
              }
              .document-descriptor-text-wrapper{
                padding: 14px;
                  background: linear-gradient(0deg, rgb(2, 0, 36) 0%, rgba(252, 221, 1, 0.26) 0%, rgba(252, 222, 11, 0.29) 100%);
                  font-size: 13.5px;
                  border-radius: 0px 0px 10px 10px;
                  display: block;
              }
              .keyTakeaways-info-icn{
                height: 22px;
                width:22px;
                border-radius: 14px;
                margin-right: 5px;
                float: right;
              }
              .message-text>table {
                margin-top: 10px;
                font-size: 0.9em;
                /* min-width: 400px; */
                /* box-shadow: 0 0 20px rgba(0, 0, 0, 0.15); */
              }
              .message-text>table>thead tr {
                color: #ffffff;
                text-align: center;
                font-weight: bold;
              }
              .message-text>table,
              .message-text>table th,
              .message-text>table td {
                border: 1px solid #A9A9A9;
                border-collapse: collapse;
              }
              .message-text>table th,
              .message-text>table td {
                padding: 10px 10px;
                color: #000000;
              }
              .message-text>table th {
                text-align: center;
              }
              .message-text
              {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                overflow: auto;
              }
              .message-text>table{
                margin-left: 0px;
              }
              .greenlight-table-wrapper table{
                border-style: solid;
                border-color: black;
              }
              .greenlight-table-wrapper table tbody tr td,.greenlight-table-wrapper table thead tr th {
                border-right-width: 1px;
                border-top-width: 1px;
                border-bottom-width: 0px;
                border-left-width: 0px;
                border-style: solid;
                border-color: black;
              }
             `;
  },
  getDocumentPreviewKeywordColorCode() {
    return [
      "#ff7f50",
      "#b0e0e6",
      "#dda0dd",
      "#ffdab9",
      "#c1ffc1",
      "#00bfff",
      "#ffd700",
      "#adff2f",
      "#e9967a",
      "#f08080",
      "#32cd32",
      "#ffb6c1",
      "#ffa07a",
      "#87cefa",
      "#66cdaa",
      "#ffa500",
      "#da70d6",
      "#eee8aa",
      "#9aff9a",
      "#afeeee",
      "#db7093",
      "#f4a460",
      "#ee82ee",
      "#ffff00",
      "#9acd32",
    ];
  },

  getExcludeKeywords() {
    return [
      "a",
      "am",
      "do",
      "he",
      "her",
      "hers",
      "him",
      "his",
      "his",
      "i",
      "is",
      "it",
      "its",
      "me",
      "mine",
      "much",
      "my",
      "our",
      "ours",
      "she",
      "their",
      "them",
      "they",
      "was",
      "what",
      "why",
      "will ",
      "you",
      "your",
      "yours",
      "in",
      "on",
      "-",
    ];
  },
  getSelectedYearForRecentlyAddedUpdated(appliedFilter) {
    if (appliedFilter === "All") return { min: 0, max: 6 };
    else if (appliedFilter === "Earlier than Yesterday")
      return { min: 0, max: 5 };
    else if (appliedFilter === "Earlier than One Week Ago")
      return { min: 0, max: 4 };
    else if (appliedFilter === "Earlier than One Month Ago")
      return { min: 0, max: 3 };
    else if (appliedFilter === "Earlier than Six Months Ago")
      return { min: 0, max: 2 };
    else if (appliedFilter === "Earlier than One Year Ago")
      return { min: 0, max: 1 };
    else if (appliedFilter === "One Year Ago or sooner")
      return { min: 1, max: 6 };
    else if (appliedFilter === "One Year Ago to Yesterday")
      return { min: 1, max: 5 };
    else if (appliedFilter === "One Year Ago to One Week Ago")
      return { min: 1, max: 4 };
    else if (appliedFilter === "One Year Ago to One Month Ago")
      return { min: 1, max: 3 };
    else if (appliedFilter === "One Year Ago - Six Months Ago")
      return { min: 1, max: 2 };
    else if (appliedFilter === "Six Months Ago or sooner")
      return { min: 2, max: 6 };
    else if (appliedFilter === "Six Months Ago to Yesterday")
      return { min: 2, max: 5 };
    else if (appliedFilter === "Six Months Ago to One Week Ago")
      return { min: 2, max: 4 };
    else if (appliedFilter === "Six Months Ago - One Month Ago")
      return { min: 2, max: 3 };
    else if (appliedFilter === "One Month Ago or sooner")
      return { min: 3, max: 6 };
    else if (appliedFilter === "One Month Ago to Yesterday")
      return { min: 3, max: 5 };
    else if (appliedFilter === "One Month Ago - One Week Ago")
      return { min: 3, max: 4 };
    else if (appliedFilter === "One Week Ago or sooner")
      return { min: 4, max: 6 };
    else if (appliedFilter === "One Week Ago - Yesterday")
      return { min: 4, max: 5 };
    else if (appliedFilter === "Yesterday") return { min: 5, max: 6 };
    else return { min: 0, max: 6 };
  },
  getSelectedYearDisplay(yearSelection) {
    if (yearSelection.min === 0 && yearSelection.max === 6) return "All";
    else if (yearSelection.min === 0 && yearSelection.max === 5)
      return "Earlier than Yesterday";
    else if (yearSelection.min === 0 && yearSelection.max === 4)
      return "Earlier than One Week Ago";
    else if (yearSelection.min === 0 && yearSelection.max === 3)
      return "Earlier than One Month Ago";
    else if (yearSelection.min === 0 && yearSelection.max === 2)
      return "Earlier than Six Months Ago";
    else if (yearSelection.min === 0 && yearSelection.max === 1)
      return "Earlier than One Year Ago";
    else if (yearSelection.min === 1 && yearSelection.max === 6)
      return "One Year Ago or sooner";
    else if (yearSelection.min === 1 && yearSelection.max === 5)
      return "One Year Ago to Yesterday";
    else if (yearSelection.min === 1 && yearSelection.max === 4)
      return "One Year Ago to One Week Ago";
    else if (yearSelection.min === 1 && yearSelection.max === 3)
      return "One Year Ago to One Month Ago";
    else if (yearSelection.min === 1 && yearSelection.max === 2)
      return "One Year Ago - Six Months Ago";
    else if (yearSelection.min === 2 && yearSelection.max === 6)
      return "Six Months Ago or sooner";
    else if (yearSelection.min === 2 && yearSelection.max === 5)
      return "Six Months Ago to Yesterday";
    else if (yearSelection.min === 2 && yearSelection.max === 4)
      return "Six Months Ago to One Week Ago";
    else if (yearSelection.min === 2 && yearSelection.max === 3)
      return "Six Months Ago - One Month Ago";
    else if (yearSelection.min === 3 && yearSelection.max === 6)
      return "One Month Ago or sooner";
    else if (yearSelection.min === 3 && yearSelection.max === 5)
      return "One Month Ago to Yesterday";
    else if (yearSelection.min === 3 && yearSelection.max === 4)
      return "One Month Ago - One Week Ago";
    else if (yearSelection.min === 4 && yearSelection.max === 6)
      return "One Week Ago or sooner";
    else if (yearSelection.min === 4 && yearSelection.max === 5)
      return "One Week Ago - Yesterday";
    else if (yearSelection.min === 5 && yearSelection.max === 6)
      return "Yesterday";
    else return "";
  },
  getRecentlyAddedUpdatedSelectedYearDisplay(yearSelection) {
    if (yearSelection.min === 0 && yearSelection.max === 6) return "All";
    else if (yearSelection.min === 0 && yearSelection.max === 5)
      return "Earlier than Yesterday";
    else if (yearSelection.min === 0 && yearSelection.max === 4)
      return "Earlier than 1 Week Ago";
    else if (yearSelection.min === 0 && yearSelection.max === 3)
      return "Earlier than 1 Month Ago";
    else if (yearSelection.min === 0 && yearSelection.max === 2)
      return "Earlier than 6 Months Ago";
    else if (yearSelection.min === 0 && yearSelection.max === 1)
      return "Earlier than 1 Year Ago";
    else if (yearSelection.min === 1 && yearSelection.max === 6)
      return "1 Year Ago or sooner";
    else if (yearSelection.min === 1 && yearSelection.max === 5)
      return "1 Year Ago to Yesterday";
    else if (yearSelection.min === 1 && yearSelection.max === 4)
      return "1 Year Ago to 1 Week Ago";
    else if (yearSelection.min === 1 && yearSelection.max === 3)
      return "1 Year Ago to 1 Month Ago";
    else if (yearSelection.min === 1 && yearSelection.max === 2)
      return "1 Year Ago - 6 Months Ago";
    else if (yearSelection.min === 2 && yearSelection.max === 6)
      return "6 Months Ago or sooner";
    else if (yearSelection.min === 2 && yearSelection.max === 5)
      return "6 Months Ago to Yesterday";
    else if (yearSelection.min === 2 && yearSelection.max === 4)
      return "6 Months Ago to 1 Week Ago";
    else if (yearSelection.min === 2 && yearSelection.max === 3)
      return "6 Months Ago - 1 Month Ago";
    else if (yearSelection.min === 3 && yearSelection.max === 6)
      return "1 Month Ago or sooner";
    else if (yearSelection.min === 3 && yearSelection.max === 5)
      return "1 Month Ago to Yesterday";
    else if (yearSelection.min === 3 && yearSelection.max === 4)
      return "1 Month Ago - 1 Week Ago";
    else if (yearSelection.min === 4 && yearSelection.max === 6)
      return "1 Week Ago or sooner";
    else if (yearSelection.min === 4 && yearSelection.max === 5)
      return "1 Week Ago - Yesterday";
    else if (yearSelection.min === 5 && yearSelection.max === 6)
      return "Yesterday";
    else return "";
  },
};


export const recentlyAddedUpdated = [
  {
    key: "Recently Added_Updated",
    doc_count: 14529,
  },
  //, {
  //     "key": "Recently Added_Updated/Earlier than One Year Ago",
  //     "doc_count": 9587
  // },
  // {
  //     "key": "Recently Added_Updated/One Year Ago - Six Months Ago",
  //     "doc_count": 7859
  // },
  // {
  //     "key": "Recently Added_Updated/Six Months Ago - One Month Ago",
  //     "doc_count": 6589
  // },
  // {
  //     "key": "Recently Added_Updated/One Month Ago - One Week Ago",
  //     "doc_count": 5478
  // },
  // {
  //     "key": "Recently Added_Updated/One Week Ago - Yesterday",
  //     "doc_count": 3258
  // },
  // {
  //     "key": "Recently Added_Updated/Yesterday",
  //     "doc_count": 256
  // }
];

export const DocumentPreviewOrderBy = {
  Hits: "Hits",
  Pages: "Pages",
};
export const DocumentPreviewSearch = {
  Search: "Search",
  Collapse: "Collapse",
};

export const PubMedFilters = {
  "Drugs - JNJ": 1,
  "Drugs - Competitor": 2,
  "Drug Dosing And Administration": 3,
  "Disease States": 4,
  "Real World Evidence": 5,
  Language: 6,
};
export const PubMedFiltersGenAI = {
  "Drugs - JNJ": 1,
  "Drugs - Competitor": 2,
  "Drug Dosing And Administration": 3,
  "Disease States": 4,
  "Real World Evidence": 5,
  "Language": 6,
  "Compounds": 7,
  "Journal": 8,
  "Mesh terms": 9,
  "Publication Type": 10,
};

export const CSEPSelectedProduct = [
  "cinnarizine",
  "domperidone",
  "flunarizine hydrochloride",
  "galantamine",
  "galantamine HBr",
  "haloperidol",
  "haloperidol decanoate",
  "hydromorphone hydrochloride",
  "itraconazole",
  "levofloxacin",
  "mebendazole",
  "methylphenidate HCl",
  "oxybutynin chloride ER",
  "pancrelipase",
  "pentosan polysulfate sodium",
  "rabeprazole ER",
  "rabeprazole sodium",
  "risperidone",
  "risperidone Consta",
  "risperidone M - TAB",
  "topiramate",
  "tramadol hydrochloride",
  "tramadol hydrochloride - acetaminophen",
];

export const CSEPDocumentType = [
  "Clinical Safety Documents",
  "ClinicalTrials.gov Records",
  "Communication Materials",
  "Competitive Intelligence",
  "Copy Review Pieces",
  "Labeling Documents - Core, EU, US",
  "Labeling Documents - Rest of World",
  "Medical Education Event Materials",
  "Medical Literature",
  "Medical Literature Compilations",
  "Scientific Response Documents",
  "Slide Decks",
  "Submission-Related Documents",
  "Training, Congress and Internal Materials",
];
export const filterMapping = {
  "ACClinicalTrials/Clinical Trials/": "Clinical Trials - JNJ/",
  "ACCompetitorDrugs/Competitor Drugs/": "Drugs - Competitor/",
  "ACCongressesPath/": "Congress Names/",
  "ACJNJDrugs/JNJ Drugs/": "Drugs - JNJ/",
  "ACTherapeuticAreas/Therapeutic Areas/": "Disease States/",
  "ContentSource/": "Content Source/",
  "mpBoostRegions/": "Regions/",
  "mpClinicalTrials/": "Clinical Trials - JNJ/",
  "mpComponentName/": "Document Subtypes/",
  "mpCongressPublicationYear/": "Publication Year/",
  "mpDocumentType/": "Document Type/",
  "mpLanguage/": "Language/",
  "mpPhaseOfStudy/": "Phase of Study/",
  "mpSubmissionRelated/": "Document Subtypes/",
  "semCompetitorDrugs/": "Drugs - Competitor/",
  "semDrugDosingAdmin/": "Drug Dosing And Administration/",
  "semJNJDrugs/": "Drugs - JNJ/",
  "semRWE/": "Real World Evidence/",
  "semTAs/": "Disease States/",
  "ACDocType/": "Copy Review Piece Key Fields/",
  "/1Scientific Responses (All but PH TA)": "/Scientific Responses",
  "/Scientific Responses (All but PH TA)": "/Scientific Responses",
  "/Scientific Responses/Standard Response Documents": "/Scientific Responses",
  "Content Source/SharePoint Online - 2WIRE": "Content Source/2WIRE",
  "/AD26.COV2.S": "/Ad26.COV2.S",
  //"/Labeling Documents":"/Labeling Documents - Core, EU, US",
  "Disease States/CNS/CNS Diseases": "Disease States/CNS Diseases",
  "Drugs - JNJ/Cardiovascular Drugs/Pulmonary Hypertension Drugs":
    "Drugs - JNJ/Pulmonary Hypertension Drugs",
  "Drugs - JNJ/Hematology Drugs/ibrutinib":
    "Drugs - JNJ/Oncology Drugs/Hematology Drugs/ibrutinib",
  "/Solid Tumor Drugs/erdafitinib":
    "/Solid Tumor Drugs/Tyrosine Kinase Inhibitors/erdafitinib",
  "Content Source/Medical Literature Publications Above 2012":
    "Document Type/Medical Literature",
  "Content Source/Medical Literature Publications Till 2012":
    "Document Type/Medical Literature",
  "Content Source/Medical Literature Abstract-Presentation-Posters":
    "Document Type/Medical Literature",
  "Content Source/ERIS Labeling (RIMdocs)":
    "Document Type/Labeling Documents - Core, EU, US;Document Type/Labeling Documents - Rest of World",
  "mpdocumenttype/": "Document Type/",
  "Document Type/Training Materials":
    "Document Type/Training, Congress and Internal Materials",
  "/Psychiatry Drugs/esketamine":
    "/Psychiatry Drugs/Antidepressant Drugs/esketamine",
  "/Psychiatry Drugs/PP1M": "/Psychiatry Drugs/Antipsychotic Drugs/PP1M",
  "/Psychiatry Drugs/PP3M": "/Psychiatry Drugs/Antipsychotic Drugs/PP3M",
  "/Antiviral Drugs Respiratory/Anti-Influenza Virus Drugs":
    "/Antiviral Drugs Respiratory/Antiviral Drugs Influenza",
  "/Integrated Read-Outs (IROs) - iMedical Insights": "/iMedical Insights",
  "/Oncology/": "/Oncology Diseases/",
  "/Q&A": "/Q%26A",
  ">": ";",
};
export const snippetLongString = (snippet, count = 100) => {
  if (snippet.length > count) {
    let text = snippet.substring(0, count); //cuts to 70
    text = text.substring(0, 100); //cuts from last space (to avoid cutting the middle of a word)
    return text;
  }
  return snippet;
};
export const nlpDocumnetTypeMapping = {
  "Labeling Documents": "Document Type/Labeling Documents - Core, EU, US;Document Type/Labeling Documents - Rest of World",
  "Scientific Response Documents": "Document Type/Scientific Response Documents",
  "Slide Decks": "Document Type/Slide Decks",
  "Medical Literature": "Document Type/Medical Literature/Posters"
};
// export const assistantDocumnetTypeMapping = {
//   "Labels": "Document Type/Labeling Documents - Core, EU, US",
//   "ScientificReponses": "Document Type/Scientific Response Documents/Scientific Responses",
//   "SlideDecks": "Document Type/Slide Decks",
// };
export const assistantDocumnetTypeMappingForOther = {
  "Labels": "Document Type/Labeling Documents - Core, EU, US/US Labeling/Physician Insert/USPI Current clean version (Clean, In-Use)",
  "ScientificReponses": "Document Type/Scientific Response Documents/Scientific Responses",
};
export const assistantDocumnetTypeMappingForMICC = {
  "HCP": "Target Audience/HCP",
  "Consumer": "Target Audience/Consumer",
};
export const assistantDocumnetTypeCountriesFilter = "Countries/United States";
export const assistantDocumnetTypeSRFilter = "Document Type/Scientific Response Documents/Scientific Responses";
export const doaminMapping = {
  "ERIS": "RIMdocs",
  "ERIS_LL": "RIMdocs_LL",
  "TrialCatalog": "CTGov",
  "Navigator": "SKM",
  "SFM": "SFM",
  "SRAP": "SRAP",
  "iMR": "iMR",
  "SRD": "SRD",
  "CMIR": "CMIR",
  "MIAs": "MIAs",
  "SR": "SR",
  "MLR": "MLR",
  "PERC": "PERC",
  "IROs": "IROs",
  "domain": "domain",
  "GCSR": "GCSR",
  "2WIRE": "2WIRE",
}

export const greetings = [
  "'Allo",
  "'Allo 'Allo",
  "Aye oop",
  "Ay up",
  "Ahoy",
  "G'day",
  "Greetings",
  "Hello",
  "Hey there",
  "Hey",
  "Hi there",
  "Hi",
  "Hiya",
  "How are things",
  "How are ya",
  "How ya doin'",
  "How's it goin'",
  "How's it going",
  "How's life",
  "Howdy",
  "Sup",
  "What's new",
  "What's up",
  "Yo",
  "Good morning",
  "Good afternoon",
  "Good evening",
  "It’s nice to meet you",
  "It’s a pleasure to meet you",
  "What’s up",
  "Nice to meet you",
  "Hi, how’s it going?",
  "Hey, what’s up?"
]
export const DomainMapping = {
  2: "RIMdocs",
  7: "CTGov",
  8: "RIMdocs_LL",
  11: "SKM",
  19: "CMIR_LATAM",
  20: "SR",
  21: "CMIR",
  22: "SRAP",
  23: "GCSR",
  24: "SRD",
  25: "MLR",
  27: "MLR",
  28: "MLR",
  29: "SFM",
  31: "2WIRE",
  32: "2WIRE",
  33: "iMR",
  34: "iMR",
  35: "iMR_LATAM",
  36: "PERC",
  37: "IROs",
  38: "MIAs",
  39: "2WIRE",
  40: "iMR_ASPAC"
};
export const sectionAnsSeparator = 'ǂ$±@';
export const AccessGroups = ['MIKI', 'MICC'];
export const MICCGroupName = 'MICC';
export const Answers = "Answers";
export const MISEHCP = "MISEHCP";
export const MICCConsumer = "MICCConsumer";
export const AllContent = "AllContent";
export const Authoring = "Authoring";
export const VESE = "VESE";
export const LimitedUser = "LimitedUser";
export const MISEHCPFilter = "Document Type/Scientific Response Documents/Scientific Responses/HCP";
export const MICCConsumerFilter = { "Consumer": "Target Audience/Consumer" }
export const WordsMaxLength = 10000;

export const getFormattedAccessGroup = (userAccessGroup) => {
  let _userAccessGroup = [];
  if (userAccessGroup.includes("MISEHCP")) {
    _userAccessGroup.push("MISE");
  }
  if (userAccessGroup.includes("VESE")) {
    _userAccessGroup.push("V&ESE");
  }
  return _userAccessGroup.join(";");
}

// export const AllContentFilter = {
//   "Labels": "Document Type/Labeling Documents - Core, EU, US/US Labeling/Physician Insert/USPI Current clean version (Clean, In-Use)",
//   "HCP": "Target Audience/HCP",
//   "Consumer": "Target Audience/Consumer",
// }

export const AllContentFilter = {
  "Labels": "Document Type/Labeling Documents - Core, EU, US/US Labeling/Physician Insert/USPI Current clean version (Clean, In-Use)",
  "Scientific Responses": "Document Type/Scientific Response Documents/Scientific Responses/HCP",
  "Slide Decks": "Document Type/Slide Decks/North America",
  "Posters": "Document Type/Medical Literature/Posters",
}

export const GenAI2AllContentFilter = {
  "Labels": "Document Type/Labeling Documents - Core, EU, US/US Labeling/Physician Insert/USPI Current clean version (Clean, In-Use)",
  "Scientific Responses": "Document Type/Scientific Response Documents/Scientific Responses/HCP",
  "Slide Decks": "Document Type/Slide Decks/North America",
  "Posters": "Document Type/Medical Literature/Posters",
  "Clinical Study Reports": "Document Type/Submission-Related Documents/Clinical Study Reports",
  "Protocols": "Document Type/Submission-Related Documents/Protocols",
}

export const ExcludeWWIDForAnalyticalLogs = [643044437, 643041767, 643051747, 643053183, 643054562];

export const getCurrentDate = () => {
  var currentdate = new Date();
  var curMonth = currentdate.getUTCMonth() + 1;
  if (curMonth < 10) {
    curMonth = "0" + curMonth;
  }
  var curDate = currentdate.getUTCDate();
  if (curDate < 10) {
    curDate = "0" + curDate;
  }
  var curHour = currentdate.getUTCHours();
  if (curHour < 10) {
    curHour = "0" + curHour;
  }
  var curMin = currentdate.getUTCMinutes();
  if (curMin < 10) {
    curMin = "0" + curMin;
  }
  var curSec = currentdate.getUTCSeconds();
  if (curSec < 10) {
    curSec = "0" + curSec;
  }
  var curMil = currentdate.getUTCMilliseconds();
  if (curMil < 10) {
    curMil = "00" + curMil;
  }
  else if (curMil < 100) {
    curMil = "0" + curMil;
  }
  var datetime =
    currentdate.getFullYear() +
    "-" +
    curMonth +
    "-" +
    curDate +
    "T" +
    curHour +
    ":" +
    curMin +
    ":" +
    curSec +
    "." +
    curMil +
    "Z";
  return datetime;
}
export const multiFilesAccept = ".doc,.docx,.ppt,.pptx,.pdf,.jpeg,.jpg,.png,.gif";
export const multiFilesOnlyImageAccept = ".jpeg,.jpg,.png,.gif";
//export const multiFilesAccept = ".doc,.docx,.ppt,.pptx,.pdf";

export const DocmentTypeForProtocolNo = ["Clinical Study Reports", "Protocols", "Posters"]
export const DropdownGraphTypes = {
  scatterPlot: "Scatter Plot",
  lineCharts: "Line Charts",
  barChart: "Bar Chart",
  pieChart: "Pie Chart",
  bubbleChart: "Bubble Chart",
  donutChart: "Donut Chart",
  kaplanMeierCurve: "Kaplan Meier Curve",
  stackedBarChart: "Stacked Bar Chart"
};
export const ContentShortcutsInfo = [
  {
    "title": "Labeling Documents",
    "subtitle": "(US, EU, and Rest of World)",
    "uniqueKey": "LDCS",
    "sort": 1
  },
  {
    "title": "MCET Templates",
    "subtitle": "(Core Assets)",
    "uniqueKey": "MCECS",
    "sort": 2
  },

  {
    "title": "iMedical Insights Reports",
    "subtitle": "(IMedical Digest)",
    "uniqueKey": "MIRCS",
    "sort": 3
  },
  {
    "title": "Submission-Related and Clinical Safety Documents",
    "subtitle": "(CSRs, Protocols, IBs, RMPs, etc.)",
    "uniqueKey": "SRnCS",
    "sort": 4
  },
  {
    "title": "Scientific Communication Documents",
    "subtitle": "(Scientific Responses, Slide Decks, etc.)",
    "uniqueKey": "SCDCS",
    "sort": 5
  },

  {
    "title": "TA and Disease Dashboards",
    "subtitle": "",
    "uniqueKey": "TAnDCS",
    "sort": 6
  },
  {
    "title": "Clinical Studies Knowledge Panel",
    "subtitle": "(Quick access to data about JNJ studies and corresponding scientific evidence)",
    "uniqueKey": "CSKPCS",
    "sort": 7
  },
  {
    "title": "Key Medical Literature Documents",
    "subtitle": "(JNJ and Key Competitor)",
    "uniqueKey": "KMLCS",
    "sort": 8
  },
  {
    "title": "Education & Training Documents",
    "subtitle": "(eLearning Modules, FAQs, etc.)",
    "uniqueKey": "EnTCS",
    "sort": 9
  },
  {
    "title": "Established Products",
    "subtitle": "(Direct Access to EP Content by Product)",
    "uniqueKey": "EPCS",
    "sort": 10
  }, {
    "title": "Key Congress Literature Documents",
    "subtitle": "(Posters/Abstracts/Oral Presentations: 2022-2026)",
    "uniqueKey": "KCLCS",
    "sort": 11
  },
  {
    "title": "Copy Review Pieces",
    "subtitle": "(Promotional Materials)",
    "uniqueKey": "CRPCS",
    "sort": 12
  },
  {
    "title": "Global Medical Affairs Resources",
    "subtitle": "(GMAF)",
    "uniqueKey": "GMAFCS",
    "sort": 13
  },
]

export const mappingFilterFromAnsToCore = (renderfilters = []) => {
  let appliedCoreFilters = [];
  if (renderfilters.findIndex(x => x === 'Scientific Response/Scientific Response') != -1) {
    appliedCoreFilters.push('Document Type/Scientific Response Documents/Scientific Responses');
  }
  //   if(renderfilters.findIndex(x=>x==='Scientific Response/Scientific Response/Regions')!=-1)
  // {
  //   appliedCoreFilters.push('Document Type/Scientific Response Documents/Scientific Responses');
  //   appliedCoreFilters.push('Document Type/Scientific Response Documents/Scientific Responses');
  //   appliedCoreFilters.push('Document Type/Scientific Response Documents/Scientific Responses');
  // }
  //    if(renderfilters.findIndex(x=>x==='Scientific Response/Scientific Response/Countries')!=-1)
  // {
  //   appliedCoreFilters.push('Countries');
  // }


  renderfilters.map((item, index) => {
    if (item.startsWith('Scientific Response/Scientific Response/Regions/')) {
      appliedCoreFilters.push(item.replace('Scientific Response/Scientific Response/Regions/', "Regions/"))
    }
    else if (item.startsWith('Scientific Response/Scientific Response/Countries/')) {
      appliedCoreFilters.push(item.replace('Scientific Response/Scientific Response/Countries/', "Countries/"))
    }
    else if (item === 'Scientific Response/Scientific Response/Regions') {
      appliedCoreFilters.push("Document Type/Scientific Response Documents/Scientific Responses")
    }
    else if (item === 'Scientific Response/Scientific Response/Countries') {
      appliedCoreFilters.push("Document Type/Scientific Response Documents/Scientific Responses")
    }
    else if (item.startsWith('Scientific Response/Scientific Response/')) {
      appliedCoreFilters.push(item.replace('Scientific Response/Scientific Response', "Document Type/Scientific Response Documents/Scientific Responses"))
    }
    else if (item.startsWith('Slide Decks/Slide Decks/Regions')) {
      appliedCoreFilters.push(item.replace('Slide Decks/Slide Decks/Regions', "Document Type/Slide Decks"))
    }
    else if (item.startsWith('Slide Decks/Slide Decks/Countries')) {
      appliedCoreFilters.push(item.replace('Slide Decks/Slide Decks/Countries', "Countries"))
    }
    else if (item.startsWith('Slide Decks/Slide Decks')) {
      appliedCoreFilters.push(item.replace('Slide Decks/Slide Decks', "Document Type/Slide Decks"))
    }
    else if (item === "Labels/Labels/CCDS Current Clean In Use") {
      appliedCoreFilters.push("Document Type/Labeling Documents - Core, EU, US/Core Labeling/Company Core Data Sheets/CCDS Current clean version (Clean, In-Use)")
    }
    else if (item === "Labels/Labels/USPI Current Clean In Use") {
      appliedCoreFilters.push("Document Type/Labeling Documents - Core, EU, US/US Labeling/Physician Insert/USPI Current clean version (Clean, In-Use)")
    }
    else if (item.startsWith("Document Type/Submission-Related Documents/Clinical Study Reports")) {
      appliedCoreFilters.push("Document Type/Submission-Related Documents/Clinical Study Reports")
    }
    else if (item === "Document Type/Submission-Related Documents/Protocols") {
      appliedCoreFilters.push(item)
    }
    else if (item === "Document Type/Medical Literature/Posters") {
      appliedCoreFilters.push(item)
    }
  })
  return appliedCoreFilters;

}

export const isShowAIMode = () => {
  let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
  let _function = JSON.parse(localStorage.getItem('function'));
  let isRussian = JSON.parse(localStorage.getItem('russianuser'));

  if (isRussian) {
    return false;
  }
  else if (_function === "Medical" || userAccessGroup.includes(Answers) || userAccessGroup.includes(LimitedUser)) {
    return true;
  }
  else {
    return false
  }
  return false
}
export const isShowAIOverview = () => {
  let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
  let _function = JSON.parse(localStorage.getItem('function'));
  let isRussian = JSON.parse(localStorage.getItem('russianuser'));

  if (isRussian
    || _function === "Safety"
    || _function === "Commercial"
    || userAccessGroup.includes(LimitedUser)) {
    return false;
  }
  else if (_function === "Medical") {
    return true;
  }
  else {
    return false;
  }
  return false;
}
export const isShowAnswerCoreFilters = () => {
  let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
  let _function = JSON.parse(localStorage.getItem('function'));
  let isRussian = JSON.parse(localStorage.getItem('russianuser'));

  if (isRussian) {
    return false;
  }
  else if (userAccessGroup.includes(LimitedUser)) {
    return false;
  }
  else if ((_function === "Medical" && !userAccessGroup.includes(Answers)) ||
    (_function === "Medical" && (userAccessGroup.includes(Answers) && userAccessGroup.includes(AllContent)))) {
    return true;
  }
  else if (userAccessGroup.includes(Answers) && userAccessGroup.includes(AllContent)) {
    return true;
  }
  else if (_function === "Safety"
    || _function === "Commercial") {
    return false;
  }
  else {
    return false;
  }
  return false;
}
export const isShowAuthoring = () => {
  let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'));
  let _function = JSON.parse(localStorage.getItem('function'));
  let isRussian = JSON.parse(localStorage.getItem('russianuser'));

  if (isRussian) {
    return false;
  }
  else if (userAccessGroup.includes(LimitedUser)) {
    return false;
  }
  else if (_function === "Medical" || userAccessGroup.includes(Authoring)) {
    return true;
  }
  else if (_function === "Safety"
    || _function === "Commercial") {
    return false;
  }
  else {
    return false;
  }
  return false;
}
export const IDColumnValues = { OVID: ['PM'], Medline: [], Other: [] };
export const LocationOrigin = window.location.origin === 'https://predev-ims.jnj.com' ? window.location.origin :
  window.location.origin === "http://localhost:3000"
    ? "https://stage-ims.jnj.com"
    : window.location.origin;
